import React, { useState } from 'react';
import { Mail, ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LandingPage = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNotify = async (e) => {
    e.preventDefault();
    
    if (!email) return;
    
    setIsSubmitting(true);
    
    try {
      const response = await axios.post(`${API}/signup`, { email });
      console.log('Email signup successful:', response.data);
      
      toast.success('Thank you for your interest! We\'ll keep you updated.');
      setEmail('');
    } catch (error) {
      console.error('Email signup error:', error);
      
      if (error.response?.data?.message === 'Email already registered') {
        toast.info('You\'re already on our list!');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="landing-container">
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div className="logo-section">
            <div className="logo-icon">
              <Sparkles className="w-6 h-6" />
            </div>
            <span className="logo-text">cancompute.io</span>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge">
              <span className="badge-dot"></span>
              <span>Stealth Mode</span>
            </div>
            <h1 className="hero-title">
              Cancompute.io<br />
              <span className="title-highlight">AI Opportunities</span>
            </h1>
            <p className="hero-subtitle">
              Those that are AI and those that help AI be
            </p>
            
            <div className="hero-cta">
              <Card className="notify-card">
                <form onSubmit={handleNotify} className="notify-form">
                  <input
                    type="email"
                    placeholder="Enter your email to stay updated"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="notify-input"
                    required
                  />
                  <Button type="submit" className="notify-button" disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Notify Me'}
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </form>
              </Card>
            </div>
          </div>

          <div className="hero-image">
            <div className="image-wrapper">
              <img 
                src="https://customer-assets.emergentagent.com/job_quick-mail-3/artifacts/qwjtde8f_desk%20top.jpg" 
                alt="Legacy meets Innovation" 
                className="featured-image"
              />
              <div className="image-overlay"></div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="about-content">
          <div className="about-grid">
            <Card className="about-card">
              <div className="card-icon">
                <Sparkles className="w-8 h-8" />
              </div>
              <h3 className="card-title">Innovation at the Core</h3>
              <p className="card-description">
                Building the foundation for AI-driven opportunities that transform how we work and create.
              </p>
            </Card>

            <Card className="about-card">
              <div className="card-icon">
                <Sparkles className="w-8 h-8" />
              </div>
              <h3 className="card-title">AI Empowerment</h3>
              <p className="card-description">
                Enabling both AI systems and the people who power them to reach their full potential.
              </p>
            </Card>

            <Card className="about-card">
              <div className="card-icon">
                <Sparkles className="w-8 h-8" />
              </div>
              <h3 className="card-title">Coming Soon</h3>
              <p className="card-description">
                Something remarkable is on the horizon. Stay tuned for updates on our journey.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="contact-content">
          <h2 className="contact-title">Get in Touch</h2>
          <p className="contact-subtitle">
            Have questions or want to learn more? We'd love to hear from you.
          </p>
          <div className="contact-email">
            <Mail className="w-5 h-5" />
            <a href="mailto:contact@cancompute.io" className="email-link">
              contact@cancompute.io
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">
              <Sparkles className="w-5 h-5" />
              <span>cancompute.io</span>
            </div>
            <p className="footer-text">
              © 2025 Cancompute.io. All rights reserved.
            </p>
          </div>
          <div className="footer-right">
            <p className="footer-tagline">
              Those that are AI and those that help AI be
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;